// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** Demo Demo GET /demo */
export async function getDemo(options?: { [key: string]: any }) {
  return request<API.BaseResponseArrayString>(`/api/v1/demo`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 校验短信验证码 校验短信验证码 POST /sms/check/code */
export async function postSmsCheckCode(
  body: API.SmsCheck,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseBool>(`/api/v1/sms/check/code`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 发送短信 发送短信 POST /sms/send */
export async function postSmsSend(
  body: API.SmsInput,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseString>(`/api/v1/sms/send`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 构建分镜脚本 构建分镜脚本 POST /story/board/script */
export async function postStoryBoardScript(
  body: API.StoryBoardScriptParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseHandlerStory>(`/api/v1/story/board/script`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 构建分镜脚本(SSE返回) 构建分镜脚本(SSE返回) POST /story/board/script/sse */
export async function postStoryBoardScriptSse(
  body: API.StoryBoardScriptParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseHandlerStory>(
    `/api/v1/story/board/script/sse`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 生成故事 生成故事 POST /story/gen */
export async function postStoryGen(
  body: API.StoryBoardScriptParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseString>(`/api/v1/story/gen`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 批量取消某个stage下未开始的任务 批量取消某个stage下未开始的任务 POST /task/cancel */
export async function postTaskCancel(
  body: API.TaskHashParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseString>(`/api/v1/task/cancel`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建/更新主任务 创建/更新主任务 POST /task/create */
export async function postTaskCreate(
  body: API.Story,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseHandlerTaskDetailResp>(`/api/v1/task/create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 任务参数 TaskParam GET /task/param */
export async function getTaskParam(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getTaskParamParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseHandlerTaskParamResp>(`/api/v1/task/param`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 重试某个具体的子任务，包括失败的和用户修改prompt后 重试某个具体的子任务，包括失败的和用户修改prompt后 POST /task/retry/sub */
export async function postTaskRetrySub(
  body: API.TaskHashParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseString>(`/api/v1/task/retry/sub`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 运行阶段任务 恢复主任务 POST /task/run */
export async function postTaskRun(
  body: API.TaskHashParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseString>(`/api/v1/task/run`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取积分消耗分类 TaskParam GET /task/score/cate */
export async function getTaskScoreCate(options?: { [key: string]: any }) {
  return request<API.BaseResponseArrayHandlerTaskScoreCate>(
    `/api/v1/task/score/cate`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 查询异步任务状态,PENDING: 执行中 DONE: 执行完成 FAILED: 执行失败 查询异步任务状态 POST /task/status */
export async function postTaskStatus(
  body: API.TaskHashParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseHandlerTaskDetailResp>(`/api/v1/task/status`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 添加子任务 添加子任务 POST /task/sub/add */
export async function postTaskSubAdd(
  body: API.AddSubTaskParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseSubtaskSubTask>(`/api/v1/task/sub/add`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 批量图片和视频子任务（图片和视频是绑定的，给一个task hash即可） 批量取消某个stage下未开始的任务 POST /task/sub/delete */
export async function postTaskSubOpenApiDelete(
  body: API.TaskHashParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseString>(`/api/v1/task/sub/delete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 使用历史任务信息和结果覆盖当前任务结果和参数,用户直接上传结果图也可以复用这个接口，保持param为原sub task 的param即可 使用历史任务信息和结果覆盖当前任务结果和参数,用户直接上传结果图也可以复用这个接口，保持param为原sub task 的param即可 POST /task/sub/history/apply */
export async function postTaskSubHistoryApply(
  body: API.ApplyHistoryParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseString>(`/api/v1/task/sub/history/apply`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 更新子任务 更新子任务 POST /task/sub/update */
export async function postTaskSubUpdate(
  body: API.UpdateSubTaskParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseString>(`/api/v1/task/sub/update`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 批量更新子任务的顺序，图片和视频任务，更新其中一个，另一个也会更新 批量更新子任务的顺序，图片和视频任务，更新其中一个，另一个也会更新 POST /task/sub/update/order */
export async function postTaskSubUpdateOrder(
  body: API.UpdateSubTaskOrderParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseString>(`/api/v1/task/sub/update/order`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建一个新的用户 创建一个新的用户 POST /user/add */
export async function postUserAdd(
  body: API.CreateUserParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseUserUsers>(`/api/v1/user/add`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建会话 创建会话 POST /user/conversation */
export async function postUserConversation(
  body: API.CreateConversationParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseConversationsConversation>(
    `/api/v1/user/conversation`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 生图 生图 POST /user/conversation/gene/image */
export async function postUserConversationGeneImage(
  body: API.GenerateImageParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseMessagesMessages>(
    `/api/v1/user/conversation/gene/image`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 获取会话列表 获取会话列表 GET /user/conversation/list */
export async function getUserConversationList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getUserConversationListParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseArrayConversationsConversation>(
    `/api/v1/user/conversation/list`,
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取会话历史消息 获取会话历史消息 POST /user/conversation/messages */
export async function postUserConversationMessages(
  body: API.GetConversationMessageParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseArrayMessagesMessages>(
    `/api/v1/user/conversation/messages`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 获取用户信息 获取用户信息 GET /user/info */
export async function getUserInfo(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getUserInfoParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseUserUsers>(`/api/v1/user/info`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 用户登录注册 用户登录注册 POST /user/login */
export async function postUserLogin(
  body: API.UserLoginParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseUserUsers>(`/api/v1/user/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建留言 创建留言 POST /user/message */
export async function postUserMessage(
  body: API.CreateMessageParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseMessageUserMessage>(`/api/v1/user/message`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 修改密码/忘记密码 修改密码/忘记密码 POST /user/modify/pass */
export async function postUserModifyPass(
  body: API.CreateUserParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseString>(`/api/v1/user/modify/pass`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 检查手机号是否注册,true表示已注册，false未注册 检查手机号是否注册,true表示已注册，false未注册 POST /user/phone/check */
export async function postUserPhoneCheck(
  body: API.CheckPhoneParam,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseBool>(`/api/v1/user/phone/check`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取用户积分消费信息 获取用户积分消费信息 GET /user/score/record */
export async function getUserScoreRecord(options?: { [key: string]: any }) {
  return request<API.BaseResponseArrayScoreScore>(`/api/v1/user/score/record`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取用户任务记录 获取用户任务记录 GET /user/task/record */
export async function getUserTaskRecord(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getUserTaskRecordParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResponseArrayGithubComTyloaferVastxServiceTaskTask>(
    `/api/v1/user/task/record`,
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}
